<ion-row class="registration-page">
  @if (!endRegisterProcess) {
  <ion-col size="12" class="registration-page__container">
    <ion-card class="registration-card">
      <ion-card-header class="registration-card__header ion-no-padding">
        <app-card-header-title-subtitle
          title="registration-form-simple.title"
          subtitle="registration-form-simple.subtitle"
        />
      </ion-card-header>

      <ion-card-content class="ion-no-padding ion-no-margin">
        <form
          autocomplete="off"
          [formGroup]="registrationForm"
          class="registration-card__form registration-form"
          (ngSubmit)="submitRegistrationForm()"
        >
          <ion-grid class="ion-no-padding">
            <ion-row class="registration-form__row">
              <ion-col size="12" sizeMd="6" class="registration-form__input">
                <app-input
                  [formGroup]="registrationForm"
                  label="registration-form-simple.name"
                  formControlName="firstName"
                  maxlength="50"
                  minlength="2"
                  [required]="true"
                />
              </ion-col>
              <ion-col size="12" sizeMd="6" class="registration-form__input">
                <app-input
                  [formGroup]="registrationForm"
                  label="registration-form-simple.first-surename"
                  formControlName="lastName"
                  maxlength="50"
                  minlength="2"
                  [required]="true"
                />
              </ion-col>
            </ion-row>

            <ion-row class="registration-form__row">
              <ion-col size="12" sizeMd="6" class="registration-form__input">
                <app-input
                  [formGroup]="registrationForm"
                  label="registration-form-simple.second-surename"
                  formControlName="secondLastName"
                  maxlength="50"
                  minlength="2"
                  [required]="false"
                />
              </ion-col>
              <ion-col size="12" sizeMd="6" class="registration-form__input">
                <app-input
                  [formGroup]="registrationForm"
                  label="registration-form-simple.country"
                  formControlName="country"
                  maxlength="30"
                  type="selectwithsearch"
                  [displayValue]="
                    getCountry(registrationForm.get('country')?.value)
                  "
                  [required]="true"
                  [options]="countryList"
                />
              </ion-col>
            </ion-row>

            <ion-row class="registration-form__row">
              <ion-col size="12" class="registration-form__input">
                <app-input
                  [formGroup]="registrationForm"
                  label="registration-form-simple.company"
                  formControlName="company"
                  maxlength="50"
                  minlength="2"
                  [required]="true"
                />
              </ion-col>
            </ion-row>

            <ion-row class="registration-form__row">
              <ion-col size="12" sizeMd="6" class="registration-form__input">
                <app-input
                  [formGroup]="registrationForm"
                  label="registration-form-simple.email"
                  formControlName="email"
                  maxlength="50"
                  [required]="true"
                  type="email"
                />
              </ion-col>
              <ion-col size="12" sizeMd="6" class="registration-form__input">
                <app-input
                  [formGroup]="registrationForm"
                  label="registration-form-simple.confirm-email"
                  formControlName="validation_email"
                  maxlength="50"
                  [required]="true"
                  type="email"
                />
              </ion-col>
            </ion-row>

            <ion-row class="registration-form__row">
              <ion-col size="12" sizeMd="6" class="registration-form__input">
                <div class="password-field-wrapper">
                  <app-input
                    [formGroup]="registrationForm"
                    label="registration-form-simple.password"
                    formControlName="password"
                    maxlength="50"
                    minlength="8"
                    [type]="passwordType"
                    [required]="true"
                  />
                  @if(registrationForm.get('password')?.value) {
                  <span
                    class="password-toggle-icon"
                    (click)="togglePasswordVisibility()"
                  >
                    <i
                      class="icon"
                      [ngClass]="showPassword ? 'icon-VIEW' : 'icon-NO-VIEW'"
                    ></i>
                  </span>
                  }
                </div>
              </ion-col>
              <ion-col size="12" sizeMd="6" class="registration-form__input">
                <div class="password-field-wrapper">
                  <app-input
                    [formGroup]="registrationForm"
                    label="registration-form-simple.confirm-password"
                    formControlName="validation_password"
                    maxlength="50"
                    [type]="passwordValType"
                    [required]="true"
                  />
                  @if(registrationForm.get('validation_password')?.value) {
                  <span
                    class="password-toggle-icon"
                    (click)="toggleValPasswordVisibility()"
                  >
                    <i
                      class="icon"
                      [ngClass]="showValPassword ? 'icon-VIEW' : 'icon-NO-VIEW'"
                    ></i>
                  </span>
                  }
                </div>
              </ion-col>
            </ion-row>

            <ion-row class="registration-form__row">
              <ion-col size="12">
                <div
                  class="registration-form__password-requirements"
                  [innerHTML]="
                    'registration-form-simple.password-requirements' | translate
                  "
                ></div>
              </ion-col>
            </ion-row>

            <ion-row class="registration-form__row">
              <ion-col size="12" sizeMd="6" class="registration-form__input">
                <app-input
                  [formGroup]="registrationForm"
                  label="registration-form-simple.lang"
                  formControlName="language"
                  maxlength="20"
                  type="select"
                  [options]="langList"
                  [required]="true"
                />
              </ion-col>
              <ion-col size="12" sizeMd="6" class="registration-form__input">
                <app-input
                  [formGroup]="registrationForm"
                  label="registration-form-simple.activity-type"
                  formControlName="activityType"
                  maxlength="20"
                  type="select"
                  [options]="activityList"
                  [required]="true"
                />
              </ion-col>
            </ion-row>

            <ion-row class="registration-form__row">
              <ion-col size="12" class="registration-form__input">
                <app-input
                  [formGroup]="registrationForm"
                  label="registration-form-simple.observations"
                  formControlName="comments"
                  maxlength="100"
                  type="text-area"
                  [required]="false"
                  tootipInfo="registration-form-simple.tooltip"
                />
              </ion-col>
            </ion-row>

            <ion-row class="registration-form__row">
              <ion-col size="12" class="">
                <div class="registration-form__text">
                  <span class="registration-form--title">{{
                    'registration-form-simple.privacy_check1' | translate
                  }}</span>
                  <span>
                    {{ 'registration-form-simple.privacy_check2' | translate }}
                  </span>

                  <span>
                    {{ 'registration-form-simple.privacy_check3' | translate }}
                  </span>
                  <span>
                    {{ 'registration-form-simple.privacy_check4' | translate }}
                    <a
                      spinnerClickButton
                      class="interLink"
                      (click)="openModal()"
                    >
                      {{
                        'registration-form-simple.privacy_check5' | translate
                      }}
                    </a>
                  </span>
                </div>

                <ion-item class="registration-form__checkbox">
                  <div>
                    <ion-checkbox
                      formControlName="privacyPolicyAccepted"
                      alignment="center"
                      class="registration-form__checkbox-button"
                    >
                    </ion-checkbox>

                    <span class="registration-form__checkbox-label">
                      {{
                        'registration-form-simple.privacy_check6' | translate
                      }}
                      <a
                        spinnerClickButton
                        class="interLink"
                        (click)="openModal()"
                      >
                        {{
                          'registration-form-simple.privacy_check5' | translate
                        }}
                      </a>
                    </span>
                  </div>
                </ion-item>
              </ion-col>
            </ion-row>

            <ion-row class="registration-form__buttons">
              <ion-col size="12" sizeMd="2">
                <ion-button
                  class="form-button form-button--outline"
                  spinnerClickButton
                  fill="outline"
                  size="small"
                  (click)="goLogin(true)"
                  >{{
                    'registration-form-simple.cancel' | translate
                  }}</ion-button
                >
              </ion-col>
              <ion-col size="12" sizeMd="3">
                <ion-button
                  class="form-button form-button--solid"
                  spinnerClickButton="6000"
                  fill="solid"
                  size="small"
                  type="submit"
                  disabled="{{ !registrationForm.valid }}"
                  >{{
                    'registration-form-simple.continue' | translate
                  }}</ion-button
                >
              </ion-col>
            </ion-row>
          </ion-grid>
        </form>
      </ion-card-content>
    </ion-card>
  </ion-col>

  } @else {
  <app-auth-verification-handler
    view="register"
    [process]="internalUser ? 'registerInt' : responseStatus"
    (goBackClicked)="goBackFromVerification($event)"
    (btnContClicked)="goLogin($event)"
  />
  }
</ion-row>
